var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 544 245.8",
    style: {
      enableBackground: "new 0 0 544 245.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#ED9AB0;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "inter-est-logo-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.2,154.3l-4.2-9.8c5.7-2.5,10.1-7,12.5-12.8l9.9,4C162.9,144.1,156.4,150.8,148.2,154.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.7,157.1c-18.8,0-34.1-15.3-34.1-34.1h10.6c0,13,10.5,23.5,23.5,23.5h0.3l0.1,10.6L134.7,157.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.5,114.3c-4.8-12.1-18.5-17.9-30.5-13.1c-5.8,2.3-10.5,6.9-12.9,12.7l-9.9-4.2 c7.3-17.4,27.4-25.5,44.7-18.1c8.4,3.6,15,10.3,18.4,18.8L156.5,114.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.1,103.3c-9.4-14.6-27.9-20.4-44-14l-4-9.9c20.8-8.3,44.6-0.8,56.9,18L165.1,103.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.2,109l-9.8-4.1c2.4-5.7,5.8-10.8,10.2-15.1l7.5,7.5C105.7,100.7,103,104.7,101.2,109z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.7,169.9c-25.9-0.1-46.8-21-46.9-46.9c0-3.1,0.3-6.2,0.9-9.2l10.4,2.1c-0.5,2.4-0.7,4.7-0.7,7.1 c0,20,16.2,36.2,36.3,36.3c5,0,9.9-1,14.4-3l4.3,9.8C147.5,168.6,141.1,169.9,134.7,169.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.7,155.3L161,148c4.8-5,8-11.2,9.3-18l10.5,2C179,140.7,174.8,148.8,168.7,155.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,146.1c-12.7-30.4,1.6-65.4,32.1-78.1c3.8-1.6,7.8-2.8,11.9-3.6l2,10.5c-26.6,5.1-44.1,30.8-39,57.4 c0.6,3.3,1.6,6.6,2.9,9.7L79.6,146.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.3,178.3c-7.3-2.9-13.9-7.3-19.5-12.8l7.5-7.6c4.6,4.5,10,8.1,16,10.5L112.3,178.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.9,181.4l-2.2-10.4c16-3.3,29.4-14.4,35.5-29.6l9.9,4C182.6,163.9,166.4,177.4,146.9,181.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.2,104.9c-6-15.3-19.4-26.5-35.4-29.9l2.2-10.4c19.6,4.1,35.8,17.7,43.1,36.3L180.2,104.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.7,102h9.8v42.3h-9.8V102z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.9,125.7v18.6h-9.4v-17.2c0-5.3-2.4-7.7-6.6-7.7c-4.5,0-7.8,2.8-7.8,8.8v16.1h-9.4v-32.5h9v3.8 c2.8-2.9,6.7-4.4,10.7-4.3C250.1,111.3,255.9,115.8,255.9,125.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.2,142.7c-2.3,1.4-5,2.1-7.7,2c-7.7,0-12.1-3.9-12.1-11.6v-13.3h-5v-7.2h5v-7.9h9.4v7.9h8.1v7.3h-8.1V133 c0,2.8,1.5,4.3,4,4.3c1.4,0,2.7-0.4,3.8-1.2L285.2,142.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321,130.7h-24.6c0.9,4,4.4,6.5,9.3,6.5c3,0.1,6-1,8.1-3.1l5,5.4c-3,3.4-7.5,5.3-13.4,5.3 c-11.2,0-18.5-7.1-18.5-16.7s7.4-16.7,17.3-16.7c9.5,0,16.9,6.4,16.9,16.9C321.2,128.9,321.1,129.9,321,130.7z M296.3,125.2h16 c-0.7-4.4-4.9-7.4-9.3-6.7C299.6,119.1,296.9,121.8,296.3,125.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.5,111.3v8.7c-0.8-0.1-1.4-0.1-2.1-0.1c-5.2,0-8.6,2.8-8.6,9v15.3h-9.4v-32.5h9v4.3 C338.7,112.9,342.5,111.3,347.5,111.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.2,154.3l-4.2-9.8c5.7-2.5,10.1-7,12.5-12.8l9.9,4C162.9,144.1,156.4,150.8,148.2,154.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.7,157.1c-18.8,0-34.1-15.3-34.1-34.1h10.6c0,13,10.5,23.5,23.5,23.5h0.3l0.1,10.6L134.7,157.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.5,114.3c-4.8-12.1-18.5-17.9-30.5-13.1c-5.8,2.3-10.5,6.9-12.9,12.7l-9.9-4.2 c7.3-17.4,27.4-25.5,44.7-18.1c8.4,3.6,15,10.3,18.4,18.8L156.5,114.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.1,103.3c-9.4-14.6-27.9-20.4-44-14l-4-9.9c20.8-8.3,44.6-0.8,56.9,18L165.1,103.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.2,109l-9.8-4.1c2.4-5.7,5.8-10.8,10.2-15.1l7.5,7.5C105.7,100.7,103,104.7,101.2,109z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.7,169.9c-25.9-0.1-46.8-21-46.9-46.9c0-3.1,0.3-6.2,0.9-9.2l10.4,2.1c-0.5,2.4-0.7,4.7-0.7,7.1 c0,20,16.2,36.2,36.3,36.3c5,0,9.9-1,14.4-3l4.3,9.8C147.5,168.6,141.1,169.9,134.7,169.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,146.1c-12.7-30.4,1.6-65.4,32.1-78.1c3.8-1.6,7.8-2.8,11.9-3.6l2,10.5c-26.6,5.1-44.1,30.8-39,57.4 c0.6,3.3,1.6,6.6,2.9,9.7L79.6,146.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.3,178.3c-7.3-2.9-13.9-7.3-19.5-12.8l7.5-7.6c4.6,4.5,10,8.1,16,10.5L112.3,178.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.9,181.4l-2.2-10.4c16-3.3,29.4-14.4,35.5-29.6l9.9,4C182.6,163.9,166.4,177.4,146.9,181.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.2,104.9c-6-15.3-19.4-26.5-35.4-29.9l2.2-10.4c19.6,4.1,35.8,17.7,43.1,36.3L180.2,104.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.4,123.5h17.1v7.5h-17.1V123.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.8,130.7h-24.6c0.9,4,4.3,6.5,9.3,6.5c3,0.1,6-1,8.2-3.1l5,5.4c-3,3.4-7.5,5.3-13.4,5.3 c-11.2,0-18.5-7.1-18.5-16.7s7.4-16.7,17.3-16.7c9.5,0,16.9,6.4,16.9,16.9C410,128.9,409.9,129.9,409.8,130.7z M385.1,125.2h16 c-0.7-4.4-4.9-7.4-9.3-6.7C388.4,119.1,385.7,121.8,385.1,125.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413,141.2l3.1-6.8c3.4,2,7.3,3.1,11.3,3.1c4.3,0,6-1.1,6-3c0-5.3-19.6,0.1-19.6-12.9c0-6.2,5.6-10.5,15-10.5 c4.5,0,9.4,1,12.5,2.8l-3.1,6.7c-2.9-1.6-6.1-2.4-9.4-2.4c-4.2,0-6,1.3-6,3c0,5.5,19.6,0.2,19.6,13c0,6-5.6,10.3-15.3,10.3 C421.6,144.7,416,143.2,413,141.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469,142.7c-2.3,1.4-5,2.1-7.7,2c-7.7,0-12.1-3.9-12.1-11.6v-13.3h-5v-7.2h5v-7.9h9.4v7.9h8.1v7.3h-8.1V133 c0,2.8,1.5,4.3,4,4.3c1.4,0,2.7-0.4,3.8-1.2L469,142.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.d1899bb53785588418b38f6a232040bd.svg";
export { ForwardRef as ReactComponent };